import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const dataSlice = createSlice({
  name: "question-by-id",
  initialState: initialState,
  reducers: {
    initGetQuestionById: () => {
      return { ...initialState };
    },
    startGetQuestionById: (state) => {
      state.loading = true;
    },
    successGetQuestionById: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorGetQuestionById: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initGetQuestionById,
  startGetQuestionById,
  successGetQuestionById,
  errorGetQuestionById,
} = dataSlice.actions;

export default dataSlice.reducer;
